import { minBy, get, isEmpty } from "lodash";
import { findingUtil } from "@stormwater-software/common";

export const getFindingLabel = finding => {
  const d =
    Array.isArray(finding.commentables) && !isEmpty(finding.commentables)
    ? get(minBy(finding.commentables, "created_at"), "content")
    : finding.location;

  return `#${finding.number} - ${d}`;
};

/**
 * SW2-2583 — a finding-array answer stores each finding's label, "#352 - text", and the tag
 * select only shows a saved value while it equals an option's value exactly. So whenever the
 * label changed (a note edited, or "undefined" from the 2026-09 `note.content` mismatch) the
 * saved finding vanished from the field, and picking it again saved it twice.
 *
 * Match saved answers to the options by finding number instead, so they show again and save
 * back under the current label, once each. An answer with no `#N` (Maryland stores the bare
 * number) or no matching option is kept as it is.
 */
export const matchFindingAnswers = (answers, options) => {
  const seen = new Set();

  return answers.flatMap((answer) => {
    const number = String(answer?.value ?? '').match(/^#(\d+)/)?.[1];
    const option =
      number && options.find((o) => o.badgeLabel === `#${number}`);
    const value = option ? option.value : answer?.value;

    if (seen.has(value)) return [];

    seen.add(value);

    return [{ value }];
  });
};

export default findingUtil;
